// extracted by mini-css-extract-plugin
module.exports = {"right":"Header_right__3nXGr","select":"Header_select__2qaMX","clinic":"Header_clinic__2Jbgo"};